import { longChatPane } from "./longChatPane";

describe("chat test", () => {
  it("works", () => {
    expect(2==2);
  })
})
